export enum StreamEntityType {
	MUSIC = "MUSIC",
	VIDEO = "VIDEO",
	FILE = "FILE"
}
